import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-xl font-bold">Jon Sheppard</Link>
        
        <div className="space-x-6">
          <Link to="/" className="hover:text-gray-300">Home</Link>
          <Link to="/work" className="hover:text-gray-300">Work</Link>
          <Link to="/music-and-hobbies" className="hover:text-gray-300">Music and Hobbies</Link>
          <Link to="/contact" className="hover:text-gray-300">Contact</Link>
          <Link to="/bible" className="hover:text-gray-300">Bible</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 